import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="tools--wage"
export default class extends Controller {
  static targets = ["container", "template"]

  addAssociation(event) {
    event.preventDefault()

    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime())
    this.containerTarget.insertAdjacentHTML('beforeend', content)
  }

  removeAssociation(event) {
    event.preventDefault()

    const row = event.target.closest('[data-tools--wage-target="item"]')

    if (row.dataset.newRecord === "true") {
      row.remove()
    } else {
      const destroyInput = row.querySelector('input[name*="_destroy"]')
      if (destroyInput) {
        destroyInput.value = '1'
      }
      row.style.display = 'none'
    }
  }
}

